import { EditorDispatch } from '../../../../types/redux';
import {
  MobileSequencedFlow as MobileSequencedFlowComponent,
  MobileSequencedFlowCallbackProps,
  MobileSequencedFlowDataProps,
} from '../../components/mobile/MobileSequencedFlow';
import { isSequencedFlowStep, Section, SequencedFlowChildrenTypes, isSimpleArrow } from '@ael/core-api';
import { Stack } from 'immutable';
import { connect } from 'react-redux';
import {dismissSequencedFlow} from '../../../../actions/contentItemActions';
import {StudentStore} from '../../../../store/models/Store';
import {HistoryItem} from '../../../../store/reducers/currentSequencedFlowPositionReducer';

interface MobileSequencedFlowProps {
  currentContentItem: SequencedFlowChildrenTypes;
  onGoToSection: (section: Section) => void;
  history: Stack<HistoryItem>;
}

const mapStateToProps = (state: StudentStore, ownProps: MobileSequencedFlowProps): MobileSequencedFlowDataProps => ({
  ...ownProps,
  isStepAndDismissable:
    state.currentSequencedFlowPosition.displayed &&
    isSequencedFlowStep(ownProps.currentContentItem) &&
    isSimpleArrow(ownProps.currentContentItem.position),
});

const mapDispatchToProps = (dispatch: EditorDispatch): MobileSequencedFlowCallbackProps => ({
  onDismissSequencedContent: () => dispatch(dismissSequencedFlow()),
});

export const MobileSequencedFlow = connect(mapStateToProps, mapDispatchToProps)(MobileSequencedFlowComponent);
